var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUrgentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12280_4409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 7.49995V10.8333M10.0001 14.1666H10.0085M8.84622 3.24305L1.99215 15.0819C1.61198 15.7386 1.42189 16.0669 1.44999 16.3364C1.47449 16.5714 1.59763 16.785 1.78876 16.924C2.0079 17.0833 2.38728 17.0833 3.14605 17.0833H16.8542C17.613 17.0833 17.9923 17.0833 18.2115 16.924C18.4026 16.785 18.5258 16.5714 18.5503 16.3364C18.5783 16.0669 18.3883 15.7386 18.0081 15.0819L11.154 3.24305C10.7752 2.58875 10.5858 2.26159 10.3387 2.15172C10.1232 2.05587 9.87709 2.05587 9.66154 2.15172C9.41443 2.26159 9.22503 2.58875 8.84622 3.24305Z",
    stroke: "#EF6C00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12280_4409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgentIcon);
export default __webpack_public_path__ + "static/media/urgent-icon.0e0029d48a054502e94a35fc2e9fe869.svg";
export { ForwardRef as ReactComponent };